import { requisitesOpfList } from '@sigma-frontend-libs/commons'

export const innRegExp = /^\d{10}$|^\d{12}$/
export const ogrnRegExp = /^\d{13}$|^\d{15}$/
export const kppRegExp = /^\d{9}$/
export const okpoRegExp = /^\d{8}$|^\d{10}$/
export const bikRegExp = /^\d{9}$/
export const rsRegExp = /^\d{20}$/
export const ksRegExp = /^\d{20}$/
export const indexRegExp = /^\d{6}$/

const shortOpf = {}
for (const opf of requisitesOpfList) {
  const split = opf.split(' ')
  shortOpf[opf] = split.reduce((result, word) => {
    if (word.length > 1) {
      result += word.substring(0, 1).toUpperCase()
    }

    return result
  }, '')
}
export const opfListShort = shortOpf
